var exports = {
  "k": "x804f0401--2a3ffc--container",
};

module.exports = exports;
